<template lang="pug">
  .trivia
    Question
</template>

<script>

import Question from '@/components/trivia/Question'
import TriviaHeader from "@/components/trivia/TriviaHeader";

export default {
  name: 'trivia',
  components: {
    Question,
    TriviaHeader
  }
}
</script>


<style scoped lang="scss">
  .trivia{
    display: grid;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 1rem;
    min-height: calc(100vh - 124px - 158px);
  }
</style>
